module.exports = __webpack_public_path__ + "static/media/icon-mobile-transparent.665c22c1.svg";